<template>
    <div>
        <div class="header  mt-5">
            {{ $vuetify.lang.t('$vuetify.employee.employeeMamagement') }}
            <div class="">
                <v-btn
                    class="ml-3"
                    @click="goToImportPage()"
                    v-if="permissionUpdate"
                    height="40"
                    outlined
                    color="primary">
                    + {{ $vuetify.lang.t('$vuetify.employee.import') }}
                </v-btn>

                <v-btn
                    class="ml-3"
                    @click="createEmployee()"
                    v-if="permissionCreate"
                    height="40"
                    color="primary">
                    + {{ $vuetify.lang.t('$vuetify.employee.createNewEmployee') }}
                </v-btn>
            </div>
        </div>
        <div class="sub-header-employee">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="$vuetify.lang.t('$vuetify.employee.searchBy')"
                        solo
                        height="40"
                        @keyup.enter="getEmployeesPagination()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        @click="searchEmployee()"
                        color="primary"
                        outlined
                        height="40">
                        {{ $vuetify.lang.t('$vuetify.employee.search') }}
                    </v-btn>
                </div>

                <div class="status-filter">
                    <v-select
                        @change="getEmployeesPagination()"
                        v-model="employeeStatus"
                        item-text="text"
                        item-value="value"
                        :items="employeeStatusDropdown"
                        outlined
                        height="40"
                        background-color="#ffffff">
                    </v-select>
                </div>

                <div class="employment-filter">
                    <v-select
                        @change="getEmployeesPagination()"
                        v-model="employeeEmployment"
                        item-text="text"
                        item-value="value"
                        :items="employeeEmploymentDropdown"
                        outlined
                        height="40"
                        background-color="#ffffff">
                    </v-select>
                </div>
                <div class="has-face-filter">
                    <v-select
                        @change="getEmployeesPagination()"
                        v-model="employeeFaceFilter"
                        item-text="text"
                        item-value="value"
                        :items="employeeFaceItem"
                        outlined
                        height="40"
                        background-color="#ffffff">
                    </v-select>
                </div>
            </div>
                <v-btn
                    v-if="permissionView"
                    class="ml-3"
                    @click="exportButton()"
                    height="40"
                    outlined
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.employee.export') }}
                </v-btn>
        </div>

        <delete-modal
            ref="modalDelete"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>

        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalEmployees"
                :items="employees"
                :loading="loading">
                <template v-slot:[`item.group`]="{ item }">
                    {{ getGroup(item.group) }}
                </template>
                <template v-slot:[`item.department`]="{ item }">
                    {{ getDepartment(item.department) }}
                </template>
                <template v-slot:[`item.line`]="{ item }">
                    <div class="line">
                        <img
                            class="mr-2 line-hover"
                            width="24"
                            src="@/assets/line-logo.png"
                            @click="lineRegisCodeModal(item)" />
                    </div>
                </template>
                <template v-slot:[`item.has_face`]="{ item }">
                    <v-icon
                        v-if="item.has_face"
                        color="#6c98ba"
                        >
                        mdi-checkbox-marked-circle
                    </v-icon>
                    <v-icon
                        v-else
                        color="#ff544a"
                        >
                        mdi-close-circle
                    </v-icon>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action">
                        <v-icon
                            v-if="permissionUpdate"
                            class="mr-2"
                            @click="updateEmployee(item.id)">
                            edit
                        </v-icon>
                        <v-icon
                            v-if="permissionDelete"
                            class="mr-2"
                            @click="openModalDelete(item)">
                            delete
                        </v-icon>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <line-regis-code-modal
            ref="lineRegisCodeModal" />

        <export-employee-modal
            ref="exportEmployeeModal"
            @export-tablet-register-code="exportTabletRegisterCode()"
            @export-line-register-code="exportLineRegisterCode()"
            @export-employee="exportEmployee()" />
    </div>
</template>

<script>
import LineRegisCodeModal from '@/components/modal/LineRegisCodeModal'
import DeleteModal from '@/components/modal/DeleteModal'
import permissionConstant from '@/constants/permissions.js'
import ExportEmployeeModal from '@/components/modal/ExportEmployeeModal.vue'

export default {
    name: 'Employee',

    components: {
        LineRegisCodeModal,
        DeleteModal,
        ExportEmployeeModal
    },
    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.employee.name'), value: 'fullname', width: '22%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.contact'), value: 'person__email', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.contactNo'), value: 'person__phone_no', width: '12%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.group'), value: 'group', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.department'), value: 'department', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.status'), value: 'status', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.line'), value: 'line', width: '8%', sortable: false },
                { text: this.$vuetify.lang.t('$vuetify.employee.employeeFace'), value: 'has_face', align: 'center', width: '10%' },
                { text: '', value: 'action', width: '8%', sortable: false }
            ]
        },
        questionDelete () {
            return this.$vuetify.lang.t('$vuetify.employee.questionDelete')
        },
        msgDeleteSuccess () {
            return {
                title: this.$vuetify.lang.t('$vuetify.employee.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.employee.msgDeleteSuccess'),
                type: 'success'
            }
        },
        employeeStatusDropdown () {
            const item = this.employeeStatusItem
            // add all status to first data
            item.unshift({
                text: this.$vuetify.lang.t('$vuetify.employee.allStatus'),
                value: null
            })
            return item
        },
        employeeEmploymentDropdown () {
            const item = this.employeeEmploymentItem
            // add all status to first data
            item.unshift({
                text: this.$vuetify.lang.t('$vuetify.employee.allEmployment'),
                value: null
            })
            return item
        }
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            employees: [],
            employeeStatus: null,
            employeeStatusItem: [],
            employeeEmployment: null,
            employeeEmploymentItem: [],
            employeeFaceFilter: null,
            employeeFaceItem: [],
            totalEmployees: 0,
            loading: false,
            operationMode: '',
            updateEmployeeId: null,
            groups: [],
            departments: [],
            branchId: null,
            permissionView: false,
            permissionCreate: false,
            permissionUpdate: false,
            permissionDelete: false,
            deleteForm: {
                header: '',
                content: '',
                path: ''
            }
        }
    },

    methods: {
        exportButton () {
            this.$refs.exportEmployeeModal.openModal()
        },

        async exportTabletRegisterCode () {
            if (process.env.VUE_APP_KBANK_SERVICE === 'true') {
                await this.exportByUrl('employee-export/tablet-register-code', 'tablet-regis-code-employee.xlsx')
            }
        },

        async exportLineRegisterCode () {
            await this.exportByUrl('employee-export/line-register-code', 'line-regis-code-employee.xlsx')
        },

        async exportEmployee () {
            await this.exportByUrl('employee-export/list', 'employee-lists.xlsx')
        },

        async exportByUrl (urlLink, fileName) {
            const form = {
                branch: this.branchId,
                search: this.search,
                status: this.employeeStatus,
                employment: this.employeeEmployment,
                hasFace: this.employeeFaceFilter
            }

            this.$store.dispatch('setLoading', true)

            const response = await this.axios.post(urlLink, form, {
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'arraybuffer'
            })

            if (response && response.data) {
                this.$store.dispatch('setLoading', false)

                try {
                    const decoder = new TextDecoder('utf-8')
                    const result = JSON.parse(decoder.decode(new Uint8Array(response.data)))
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.branchFormModal.errorMessage'),
                        text: result.msg,
                        type: 'error'
                    })
                } catch (error) { // if response data is not json, export success
                    this.$util.downloadExcelFile(response.data, fileName)
                }
            }
        },

        openModalDelete (employee) {
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.employee.deleteEmployee')
            this.deleteForm.content = this.questionDelete.replace('$Name', employee.fullname)
            this.deleteForm.path = `employee/delete/${employee.id}`
            this.$refs.modalDelete.dialog = true
        },

        async lineRegisCodeModal (employee) {
            await this.$refs.lineRegisCodeModal.openModal(employee.id)
        },

        async getEmployeeStatus () {
            const res = await this.axios.get('employee/status')
            if (res && res.data && res.data.status === 'ok') {
                this.employeeStatusItem = res.data.data
            }
        },

        async getEmployeeEmployment () {
            const res = await this.axios.get('employee/employment')
            if (res && res.data && res.data.status === 'ok') {
                this.employeeEmploymentItem = res.data.data
            }
        },

        async searchEmployee () {
            this.options.page = 1
            await this.getEmployeesPagination()
        },

        async getEmployeesPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `employees?branch=${this.branchId}&page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.employeeStatus) {
                url += `&status=${this.employeeStatus}`
            }

            if (this.employeeEmployment) {
                url += `&employment=${this.employeeEmployment}`
            }

            if (this.employeeFaceFilter !== null) {
                url += `&hasFace=${this.employeeFaceFilter}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.employees = res.data.data
                this.totalEmployees = res.data.total
                this.loading = false
            }
        },

        getGroup (id) {
            const group = this.groups.find(g => g.id === id)
            return group ? group.name : '-'
        },

        getDepartment (id) {
            const department = this.departments.find(d => d.id === id)
            return department ? department.name : '-'
        },

        createEmployee () {
            this.$router.push({ name: 'EmployeeForm' }, () => {})
        },

        updateEmployee (id) {
            this.$router.push({ name: 'EmployeeForm', params: { id } }, () => {})
        },

        async getBranch () {
            this.branchId = localStorage.getItem('currentBranchId')

            if (this.branchId) {
                await this.getDataForEmployeeList()
            }
        },

        async getDataForEmployeeList () {
            if (this.branchId) {
                await this.getEmployeesPagination()
                this.departments = await this.$util.getDepartments()
                this.groups = await this.$util.getGroups(this.branchId)
            }
        },

        async deleteSuccess () {
            await this.getEmployeesPagination()
            this.$notify(this.msgDeleteSuccess)
        },

        checkPermission () {
            this.permissionView = this.$util.checkPermission(permissionConstant.employee.view)
            this.permissionCreate = this.$util.checkPermission(permissionConstant.employee.create)
            this.permissionUpdate = this.$util.checkPermission(permissionConstant.employee.update)
            this.permissionDelete = this.$util.checkPermission(permissionConstant.employee.delete)
        },

        goToImportPage () {
            this.$router.push({ name: 'EmployeeImport' }, () => {})
        },

        employeeFaceDropDown () {
            this.employeeFaceItem = [{
                text: this.$vuetify.lang.t('$vuetify.employee.allFaceStatus'),
                value: null
            }, {
                text: this.$vuetify.lang.t('$vuetify.employee.validFaceImage'),
                value: true
            }, {
                text: this.$vuetify.lang.t('$vuetify.employee.inValidFaceImage'),
                value: false
            }]
        }
    },

    async mounted () {
        await this.getEmployeeStatus()
        await this.getEmployeeEmployment()
        await this.getBranch()
        this.employeeFaceDropDown()
        this.checkPermission()
    },

    watch: {
        options: {
            async handler () {
                await this.getDataForEmployeeList()
            },
            deep: true
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getDataForEmployeeList()
                await this.getEmployeeStatus()
                await this.getEmployeeEmployment()
                this.employeeFaceDropDown()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
}

::v-deep .search-input .v-input__control > .v-input__slot {
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}

.search-input {
    width: 30%;
}

.sub-header {
    padding: 16px;
    display: flex;
    justify-content: flex-end;
}
.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    font-size: 28px;
    font-weight: bold;
}
.action {
    display: flex;
}
.line-hover {
    cursor: pointer;
}
.search-container {
    display: flex;
}
.sub-header-employee {
    display: flex;
    justify-content: space-between;
}
.status-filter, .employment-filter, .has-face-filter {
    margin-left: 25px;
}
::v-deep .status-filter {
    width: 15%;

    .v-input__append-inner {
        margin-top: 11px;
    }
}

::v-deep .employment-filter {
    width: 15%;

    .v-input__append-inner {
        margin-top: 11px;
    }
}

::v-deep .has-face-filter {
    width: 20%;

    .v-input__append-inner {
        margin-top: 11px;
    }
}
</style>
